import { Component, Host, h, Prop, State } from '@stencil/core';
import { DateTime } from 'luxon';
import { prepend0 } from './../../../utils/utils';

@Component({
  tag: 'afs-cta-countdown',
  styleUrl: 'afs-cta-countdown.sass',
  shadow: true,
})
export class AfsCtaCountdown {

  @Prop() year : number = 2021;
  @Prop() month : number = 1;
  @Prop() day : number = 31;
  @Prop() hour : number = 23;
  @Prop() minute : number = 0;
  @Prop() zone : string = "America/Edmonton";

  @Prop() exposed : boolean = false;

  @State() targetTime : any = new DateTime.fromObject({
    year: this.year,
    month: this.month,
    day: this.day,
    hour: this.hour,
    minute: this.minute,
    zone: this.zone,
  });
  @State() currentTime : any = new DateTime.local();
  @State() interval : any = null;

  @State() displayDay : number | string = null;
  @State() displayHour : number | string = null;
  @State() displayMin : number | string = null;

  componentWillLoad() {

    if (this.exposed == true) return;
    let timeDifference = this.calculateTimeDifference();
    if (timeDifference.minutes < 0) {
      timeDifference = {
        minutes: 0,
        hours: 0,
        days: 0,
      }
    }
    this.setDisplay(timeDifference);

    console.log(timeDifference);

    this.interval = setInterval(() => {
      this.currentTime = new DateTime.local();
      timeDifference = this.calculateTimeDifference();
      if (timeDifference.minutes < 0) {
        timeDifference = {
          minutes: 0,
          hours: 0,
          days: 0,
        }
        this.setDisplay(timeDifference);
        clearInterval(this.interval);
        return;
      }
      this.setDisplay(timeDifference);
    }, 60000);

  }

  calculateTimeDifference() {
    return this.targetTime.diff(this.currentTime, ['day', 'hour', 'minute']);
  }

  setDisplay(timeObject : any) {
    this.displayDay = prepend0(timeObject.days);
    this.displayHour = prepend0(timeObject.hours);
    this.displayMin = prepend0(Math.floor(timeObject.minutes));
    // console.log(this.displayDay, this.displayHour, this.displayMin);
  }

  seperateDigit(display, digit) {
    const dislayArray = display.split('');
    return dislayArray[digit - 1];
  }
 
  render() {
    return (
      <Host>
        <div class="countdown-wrapper">
          
          <div class="countdown-number-wrapper">
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(this.day), 1) : this.seperateDigit(this.displayDay, 1) }</div>
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(this.day), 2) : this.seperateDigit(this.displayDay, 2) }</div>
            <span>Days</span>
          </div>
          <div class="countdown-number-wrapper">
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(this.hour), 1) : this.seperateDigit(this.displayHour, 1) }</div>
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(this.hour), 2) : this.seperateDigit(this.displayHour, 2) }</div>
            <span>Hours</span>
          </div>
          <div class="countdown-number-wrapper">
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(Math.round(this.minute)), 1) : this.seperateDigit(this.displayMin, 1) }</div>
            <div class="countdown-numbers">{ this.exposed ? this.seperateDigit(prepend0(Math.round(this.minute)), 2) : this.seperateDigit(this.displayMin, 2) }</div>
            <span>Minutes</span>
          </div>

        </div>
      </Host>
    );
  }

}
